import { axiosLog, axiosLog_V2 } from '@/libs/api.request';
import { encodeBase64 } from '@/libs/util';

interface LogParams {
    log_type: string;
    data: string;
    base_encode: string;
}
/**
 * ELK打点
 */
const log = async (params: LogParams) => {
    return axiosLog.request({
        url: '/client/log/log',
        method: 'post',
        data: params,
        customTips: true,
        disabledNetworkErrTip: true,
    });
};

/**
 * 日志 v2
 */
const logV2 = async (params: any) => {
    console.log(['-----提交日志-----', params]);
    return axiosLog_V2.request({
        url: '/client/log/batch-log',
        method: 'post',
        data: {
            log_data: encodeBase64(JSON.stringify(params)),
            base_encode: '1',
        },
        customTips: true,
        disabledNetworkErrTip: true,
    });
    // return Promise.resolve();
};

export { logV2 };

export default log;
